import React, { useState, useContext, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { Grid, Typography } from "@material-ui/core";
import { AppointmentType, Context } from "../store";  //FB 8549
import useStyles from "../css/styles";
//FB 8549
import { GetAdminSettingValue, GetAppointmentTypeFromAdmin, GetAppointmentTypes, InsertPELogs, ValidateAppointmentType } from '../api';//FB 7997
import globalsettings from "../../../config";
import FilterPage from "../inoffice/appointmentFilter";
import { modify_AppointmentDetails } from "../actions";

// update log
// FB 7802 SK    12/14/2023    PE - Supporting Office-Specific Custom Appointment Types
// FB 7997 SK    12/28/2023    PE- When an inactive appointment is mentioned in the admin parameter we should show that in PE
// FB 8549 DK    10/21/2024    TeleHealth re-work

export default function AppointmentTypePage(props: any) {
  const classes = useStyles();
  const { state, dispatch } = useContext(Context);
  const [customApptType, setCustomAppointmentType] = useState(state.appointmentdetails.customappointmenttype);
  //FB 8549 Start
  const [appointmentTypes, setAppointmentTypes] = useState<AppointmentType[]>([]);

  const handleClick = async (type: AppointmentType) => {
    setCustomAppointmentType(type.NAME);
    sessionStorage.setItem("AppointmentType_N", type.Id.toString());
    sessionStorage.setItem("AppointmentType", type.NAME);
    sessionStorage.setItem("Duration", type.DURATION.toString());

    modify_AppointmentDetails(
      {
        appointmenttype: state.appointmentdetails.appointmenttype,
        customappointmenttype: type.NAME,
        patientType: state.appointmentdetails.patientType,
        isInsuranceExist: state.appointmentdetails.isInsuranceExist,
        insurance: {
          id: state.appointmentdetails.insurance.id,
          planId: state.appointmentdetails.insurance.planId,
          name: state.appointmentdetails.insurance.name,
          planName: state.appointmentdetails.insurance.planName,
        },
        appointmentfilter: "",
        provider: {
          id: 0,
          name: "",
        },
        location: {
          id: 0,
          name: "",
          address: "",
          region: 0,
        },
        date: new Date(),
      },
      dispatch
    );
  };
  //FB 8549 End

  const handleGoback = () => {
    if (props.origin === "PatientType") {
      props.onCallback("");
      InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Appointment Type");
    }
    else {
      props.onCallback("");
      props.insurance({ id: 0, name: "" });
      props.insuranceplan({ id: 0, name: "" });
      InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Appointment Type");
    }
  };

  function getcomponent() {
    if (customApptType != "") {
      return <FilterPage origin="PatientType" onCallback={setCustomAppointmentType} />
    }
  }

  //FB 8549 Start
  async function fetchAppointmentTypes() {
    var filter = state.appointmentdetails.appointmenttype != undefined ? state.appointmentdetails.appointmenttype : "";
    var types = await GetAppointmentTypes(filter, state.appointmentdetails.patientType);
    if (types != null) {
      setAppointmentTypes(types);
    }
  }
  //FB 8549 End

  useEffect(() => {
    fetchAppointmentTypes();
  }, []);

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  return (
    <div ref={scrollTo}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography id="chooseMessage" variant="h6">
            Choose Appointment Type
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} >
      {/* FB 8549 Begin */}
        {appointmentTypes.map((type) => (
          <Grid item key={type.Id}>
            <Button
              variant="outlined"
              onClick={() => handleClick(type)}
              className={
                customApptType === type.NAME
                  ? classes.buttonActive
                  : classes.buttonInactive
              }
            >
              {type.NAME}
            </Button>
          {/* FB 8549 End */}
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        spacing={2}
        className={classes.flexend_Grid}
        style={{
          display: customApptType === "" ? "inline-flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={classes.flexend_Grid}
          style={{ marginTop: 10 }}
        >
          <Button
            onClick={handleGoback}
            id="gobackByDate"
            variant="contained"
            className={classes.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
      <React.Fragment>{getcomponent()}</React.Fragment>
    </div>
  );
}
